import { PaymentData } from './types/common';

export const ROUTES = {
  LANDING: '/',
  RECHARGES: '/recharges',
  PAY_WITH_CARD: '/pay-with-card',
  PAYMENTS: '/payments',
  ERROR: '/error',
} as const;


export const INITIAL_PAYMENT: PaymentData = {
  cardholder: '',
  cardnumber: '',
  expiry: '',
  cvv: '',
};
